(function () {
  if (window.__ptRolex) return; window.__ptRolex = 1;
  function emit(n, p) { try { if (window.traxEmit) window.traxEmit(n, p); } catch (e) {} }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-pt]');
    if (!a) return;
    var href = a.getAttribute('href') || '';
    if (/^(sms|tel):/.test(href) || /direct\.lc\.chat/.test(href)) return;
    var pt = a.getAttribute('data-pt'), c = a.closest('[data-ph]'), ph = c ? c.getAttribute('data-ph') : '', r = a.querySelector('.pt-ref');
    var pn = pt === 'out' ? ph + '|out|' + href.split('/').pop() : ph + '|' + (r ? r.textContent.replace(/^Ref\.\s*/, '') : '') + '|' + pt;
    emit('select_promotion', { promotion_id: 'rolex-' + pt, promotion_name: pn, creative_slot: ph, link_url: href || location.pathname });
  }, true);
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d || !d.hasAttribute || !d.hasAttribute('data-pt-all') || !d.open || d.__pt) return;
    d.__pt = 1;
    var c = d.closest('[data-ph]'), ph = c ? c.getAttribute('data-ph') : '';
    emit('select_promotion', { promotion_id: 'rolex-all', promotion_name: ph + '|all', creative_slot: ph, link_url: location.pathname });
  }, true);
  var b = document.querySelector('.pt-rb');
  if (b && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      for (var i = 0; i < es.length; i++) if (es[i].isIntersecting) {
        emit('view_promotion', { promotion_id: 'rolex-view', promotion_name: b.getAttribute('data-pn') || '',
          creative_slot: b.getAttribute('data-ph') || '', link_url: location.pathname });
        io.disconnect(); break;
      }
    }, { threshold: 0.25 });
    io.observe(b);
  }
})();
